<template>
  <div
    id="gradient-header"
    :style="cssVars"
  >
    <div class="gradient">
      <slot />
    </div>
    <div id="rounded-overlay">
      <div
        v-if="!hideBackBtn"
        id="back-container"
      >
        <sn-btn
          data-cy="back"
          type="text"
          prepend-icon="$snArrowLeft"
          text="Back"
          underlined
          @click="$emit('back')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import snBtn from '~/components/snui/v2/snBtn/snBtn.vue'

export default {
  name: 'SnGradientHeader',
  components: {
    snBtn
  },
  props: {
    overlap: {
      type: Number,
      required: false,
      default: 0
    },
    hideBackBtn: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldCollapse: {
      type: Boolean,
      required: false,
      default: true
    },
    overlayRadius: {
      type: Number,
      required: false,
      default: 0
    },
    breakpoint: {
      type: Number,
      required: false,
      default: 960
    },
    headerImageUrl: {
      type: String,
      required: false,
      default: ''
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: '100%'
    }
  },
  computed: {
    backMargin () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return '24px 24px 8px 16px'
      } else if (this.collapse) {
        return '24px 24px 8px 56px'
      } else {
        return '16px 16px 8px 56px'
      }
    },
    collapse () {
      return this.$vuetify.breakpoint.width < this.breakpoint && this.shouldCollapse
    },
    cssVars () {
      const vars = {
        '--gradient-color': `${this.$vuetify.theme.themes.light.snBrand}80`,
        '--gradient-header-image': `url(${this.headerImageUrl})`,
        '--overlay-radius': this.overlayRadius + 'px',
        '--back-margin': this.backMargin,
        '--gradient-padding-bottom': this.gradientPaddingBottom,
        '--overlap': this.effectiveOverlap,
        '--gradient-position': this.gradientPosition,
        '--width': this.width
      }
      if (this.gradientPosition === 'fixed') vars.right = 0
      return vars
    },
    gradientPaddingBottom () {
      if (this.collapse) {
        return this.overlayRadius + 'px'
      } else {
        return Math.max(this.overlap, this.overlayRadius) + 'px'
      }
    },
    effectiveOverlap () {
      if (this.collapse) {
        return 'inherit'
      } else {
        return -this.overlap + 'px'
      }
    },
    gradientPosition () {
      if (this.fixed) return 'fixed'
      return 'relative'
    }
  }
}
</script>

<style scoped lang="scss">

#gradient-header {
  background: linear-gradient(270deg, var(--sn-brand-03), var(--gradient-color), var(--sn-brand-03)), var(--gradient-header-image);
  width: var(--width);
  margin-bottom: var(--overlap);
  padding-bottom: var(--gradient-padding-bottom);
  position: var(--gradient-position);
}

#rounded-overlay {
  width: 100%;
  background: #FFFFFF;
  border-radius: var(--overlay-radius) var(--overlay-radius) 0 0;
  min-height: var(--overlay-radius);
  box-shadow: 0 -6px 5px rgba(31, 31, 31, 0.04);
  position: absolute;
  bottom: -1px;
  // prevent margin collapse
  &::before {
    content: '';
    clear: both;
    display: table;
  }
}

#back-container {
  margin: var(--back-margin);
  position: absolute;
  top: 0;
  left: 0;
  &::v-deep .sn-text-btn--icon {
    padding: 0px;
  }
}
</style>
